export type YogaPose =
  | 'diamond'
  | 'standing'
  | 'other';

export const yogaPoseValues: { [key in YogaPose]: number } = {
  diamond: 0.5484,
  standing: 0.5484,
  other: 0.5484,
};


export function calculateWater(degrees: number = 0, duration: number = 0): number {
  const time = duration;
  if (time <= 0) return 0;
  return time * 9.915 * Math.exp(-0.108 * degrees);
}

export function calculateSauna(
  degrees: number = 0,
  humidity: number = 0,
  duration: number = 0
): number {
  const time = duration;
  if (time <= 0) return 0;

  const coefficient = 7 / (108 * Math.exp(-0.0222 * (degrees + humidity)));
  return time * coefficient;
}

export function calculateDynamic(
  distance: number = 0,
  duration: number = 0
): number {
  const time = duration;
  if (time <= 0) return 0;
  const speed = (distance ) / time;
  return time * Math.pow(speed + 1.06, 4) * speed / 1.05714285714;
}


export function calculateStatic(
  duration: number = 0,
  valueFromList: number
): number {
  const time = duration;
  if (time <= 0) return 0;
  return time * valueFromList;
}


export function calculateActivity(state: {
  activity: 'static' | 'water' | 'dynamic' | 'sauna' | null;
  saunaTemperature: number;
  saunaHumidity: number;
  saunaTime: number;
  dynamicTime: number;
  dynamicDistance: number;
  waterTemperature: number;
  waterTime: number;
  staticTime: number;
  staticPose: YogaPose;
}): number {
  switch (state.activity) {
    case 'water':
      return calculateWater(state.waterTemperature, state.waterTime);
    case 'dynamic':
      return calculateDynamic(state.dynamicDistance, state.dynamicTime);
    case 'sauna':
      return calculateSauna(state.saunaTemperature, state.saunaHumidity, state.saunaTime);
    case 'static':
      return calculateStatic(state.staticTime, yogaPoseValues[state.staticPose]);
    default:
      return 0;
  }
}